module.exports = __webpack_public_path__ + "img/64ba0ab.png";